import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { appendTableToGame } from '@/model/algolia/utils';
import { fetchLiveTables } from '@/model/liveTable';
import { PortalVerticalGameTilePropTypes, Table } from '@/types/gameTypes';

export const fetchTableForSearchGames = async (context: LogicContext) => {
  const games: PortalVerticalGameTilePropTypes[] = context.search.searchItems;

  const tableIds = games
    .filter(game => game.table_id)
    .map(game => game.table_id) as string[];
  if (tableIds.length === 0) {
    return context;
  }

  const tablesById: {
    [key: string]: Table;
  } = await fetchLiveTables(
    tableIds,
    context.user?.currency || config.default_currency
  );

  const gamesWithTables = games
    .map((game: PortalVerticalGameTilePropTypes) =>
      game.table_id ? appendTableToGame(game, tablesById[game.table_id]) : game
    )
    .filter(game => (game.table ? game.table.online.open : true));

  return {
    search: {
      ...context.search,
      searchItems: gamesWithTables,
    },
  };
};
